import React from 'react'
import Task from './Task'
import { useGetTasksQuery } from '../features/task/taskApi';
import { useSelector } from 'react-redux';

export default function TaskList() {
  const { projects } = useSelector(state => state.filter)
  const { keyword } = useSelector(state => state.filter)
  const { isLoading, isSuccess, data: tasks, isError, error } = useGetTasksQuery();

  let content = "";

  if (isLoading) {
    content = "Loading..."
  } else if (!isLoading && isSuccess && tasks?.length > 0 && projects) {
    content = tasks?.filter(project => project.taskName.toLowerCase().includes(keyword))?.filter(project => projects?.includes(project.project.projectName))?.map(task => <Task key={task.id} task={task} />)
  } else if (!isLoading && isSuccess && tasks?.length === 0) {
    content = "No task here."
  } else if (!isLoading && isError) {
    content = error?.message
  }

  return (
    <div className="lws-task-list">
      {content}
    </div>
  )
}
